var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 280,
    viewBox: "0 0 248 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_2225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.06 91.6796C153.42 81.0596 161.38 59.6096 161.38 59.6096C157.99 60.1296 149.26 78.5496 149.26 78.5496C146.23 74.2696 151.79 56.2496 150.84 57.0996C149.89 57.9496 146.32 60.5196 144.18 64.1496C142.88 66.3596 138.68 73.1396 133.09 78.1196C129.48 81.3396 124.58 82.8896 121.84 85.0196C114.87 90.4496 115.01 100.87 113.45 98.8096C111.89 96.7496 113.89 91.7796 110.64 94.1096C107.39 96.4396 103.89 108.64 103.85 111.93C103.81 115.22 106.75 114.6 107.09 115.61C107.43 116.62 104.67 119.4 104.67 126.91C104.67 134.42 107.52 151.57 104.9 160.59C102.28 169.61 81.3604 170.65 81.3604 170.65C81.3604 170.65 86.1204 152.74 85.5804 147.3C85.0504 141.86 84.0404 133.02 87.7904 128.37C91.5404 123.72 95.7204 122.25 96.9704 118.21C98.2204 114.17 94.7703 109.76 95.5903 106.19C96.4103 102.62 92.8803 95.9896 96.7403 91.9296C100.6 87.8696 104.41 81.3796 106.73 72.0896C109.05 62.7996 115.57 58.2896 123.92 51.4296C132.27 44.5696 141.78 41.1696 150.84 40.3896C159.91 39.5996 165.68 44.3996 165.68 44.3996C165.68 44.3996 175.38 41.3096 187.18 46.8696C198.99 52.4296 205.5 69.2496 207.87 75.8896C210.24 82.5396 211.82 110.58 211.56 115.86C211.3 121.14 203.51 133.66 201.27 136.84C199.03 140.02 194.33 156.29 192.93 161.59C191.53 166.89 182.9 172.21 176.73 175.78C170.56 179.36 170.19 187.77 170.19 187.77C159.94 184.01 154.46 165.14 155.05 162.28C155.64 159.42 161.16 157.5 163.07 156.47C164.98 155.44 167.07 152.61 171.1 149.41C175.13 146.21 173.99 149.71 177.8 148.56C181.61 147.41 188.66 137.94 187.34 135.5C186.02 133.05 188.96 116.41 189.83 111.78C190.7 107.15 187.06 101.09 187.06 101.09C184.47 102.5 184.47 110.1 184.47 110.1C184.47 110.1 185.02 108.63 182.12 106.2C179.22 103.77 182.56 105.53 173.65 98.2596C173.65 98.2596 169.52 97.1296 164.05 91.6696L164.06 91.6796Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0303 299.88C24.2503 293.28 24.8203 288.84 23.7903 277.69C22.4703 250.5 19.9303 225.57 35.7103 204.21C38.6303 200.14 43.6403 198.36 49.2103 196.65C54.4703 195.14 62.1303 191.94 66.5303 191C67.8503 190.96 68.0503 192.28 69.4303 194.74C70.1603 196.08 70.9103 197.37 71.7503 198.7C76.3903 206.25 85.2803 215.78 92.8403 220.36C114.75 236.26 158.56 237.75 176.73 206.97C178.51 204.04 179.27 202.24 180.67 202.02C181.49 201.89 182.49 202.17 183.39 202.5C187.85 204.17 198.49 208.54 203.72 211.74C206.07 213.14 208.15 214.88 209.22 217.39C210.6 220.53 212.32 225.69 213.73 232C216.15 241.94 216.04 253.78 214.48 264.27C213.01 276.03 211.27 290.05 210.3 297.87C209.9 300.99 209.71 302.98 209.5 303.84C209.29 304.72 208.88 304.69 208.15 304.71C196.16 304.77 70.9503 304.68 29.4003 304.71C27.3603 304.46 26.9803 302.05 26.0803 300.03L26.0303 299.88Z",
    fill: "#A30FFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38 38.7599C161.38 38.7599 148.05 30.7699 123.66 46.8699C99.2702 62.9799 104.17 70.9199 102.06 75.4199C99.9502 79.9199 93.5202 87.5399 92.7602 97.1399C92.0002 106.74 96.1502 105.5 95.2902 115.62C94.4302 125.74 85.4302 123.74 85.4302 138.94C85.4302 154.14 87.5102 162.96 80.4102 171.95",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14 38.9403C171.14 38.9403 189.57 35.8303 201.5 53.3903C213.44 70.9403 213.25 90.6503 213.26 93.2503",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45 80.7998C204.45 80.7998 208.08 91.6998 211.2 97.1498C214.31 102.6 218.41 112.28 211.86 123.35C205.32 134.42 200.65 131.83 197.88 147.91C195.11 164 190.31 167.11 184.41 170.05C178.51 172.99 170.55 180.82 171.15 187.1",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 152.41C183 152.41 179.61 163.55 172.57 167.29C165.54 171.03 164.17 169.92 161.91 174.05",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 50.1797C183 50.1797 187.7 58.7897 184.48 68.4997C181.27 78.2097 185.6 91.5297 185.6 91.5297",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84 48.8301C139.84 48.8301 116.4 69.8201 114.15 76.9501C111.9 84.0801 108.09 89.1401 103.85 90.9401",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18 130.25C101.18 130.25 92.5301 137.94 92.8001 147.77C93.0701 157.6 96.9901 159.51 96.9901 159.51",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.04 65.9805C143.04 65.9805 136.46 78.7705 127.82 82.5005C119.18 86.2305 115.63 92.9505 114.29 98.8105",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.01 94.8701C110.01 94.8701 100.46 107.37 105.83 115.62",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33 112.67C108.33 112.67 100.15 127.67 112.25 144.8C124.35 161.93 135.71 164.17 153.64 159.5C171.57 154.83 177.8 139.96 177.8 139.96",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.97 135.51C187.97 135.51 183.71 151.85 172.46 147.98",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88 105.25C188.88 105.25 193.21 123.14 185.94 131.55",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19 55.29C152.19 55.29 144.69 73.02 149.31 81.06",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38 57.0996C161.38 57.0996 148.56 86.3496 171.14 96.4596",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25 78.5498C176.25 78.5498 173.61 101.79 183.67 111.79",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 131.55C127.3 131.55 136.08 143.76 152.19 144.8",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52 115.25C151.52 115.25 148.82 120.28 148.47 124.32",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.99 86.9396C149.99 86.9396 139.48 83.9996 135.16 85.1496",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7 100.88C172.7 100.88 178.35 104.91 179.52 106.77",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.27 194.92C172.27 194.92 143.31 188.85 155.28 159.04",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.22 143.77C106.22 143.77 113.29 177.99 75.4102 184.75",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3896 184.74C70.3896 184.74 84.7096 226.24 129.36 226.77C167.77 226.77 177.45 195.43 177.45 195.43",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 197.55C187.58 199.99 195.4 203.89 200.77 206.45C208.31 209.66 213.13 214.71 215.92 222.11C217.71 226.49 218.35 230.83 218.42 235.43C218.67 244.98 218.44 262.54 217.72 276.86C217.32 284.55 216.82 293 215.35 299.43",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1504 187.1C66.1504 187.1 59.4904 190.72 53.6104 191.97C47.7304 193.22 28.5304 194.93 21.6104 226.77C14.6904 258.61 17.8004 298.39 17.8004 298.39",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4199 219.57C57.4199 219.57 67.4099 276.43 67.4099 292.35",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46 224.54C186.46 224.54 167.92 280.58 168.46 292.35",
    stroke: "black",
    strokeWidth: 3.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.88 102.62C139.985 102.62 141.69 100.914 141.69 98.81C141.69 96.7058 139.985 95 137.88 95C135.776 95 134.07 96.7058 134.07 98.81C134.07 100.914 135.776 102.62 137.88 102.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.11 120.29C173.214 120.29 174.92 118.584 174.92 116.48C174.92 114.376 173.214 112.67 171.11 112.67C169.006 112.67 167.3 114.376 167.3 116.48C167.3 118.584 169.006 120.29 171.11 120.29Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_2225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter4);
export default __webpack_public_path__ + "static/media/Character4.1125a76ff6f7d7515f1e12de1b40d89b.svg";
export { ForwardRef as ReactComponent };